import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import queryString from "query-string";
import Switch from "react-switch";
PouchDB.plugin(PouchdbFind);

export default class PerfilNovo extends Component {
  constructor(props) {
    super(props);
    this.notificar = this.notificar.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.cadastrar = this.cadastrar.bind(this);
    this.loadModulos = this.loadModulos.bind(this);
    this.loadPerfil = this.loadPerfil.bind(this);
    this.onChangeModulo = this.onChangeModulo.bind(this);

    this.state = {
      _id: null,
      action: "CADASTRAR", //EDITAR

      desc: "",
      modulos: [],
      perfilEditar: null,

      errors: {
        desc: false,
      },
    };
  }

  async componentDidMount() {
    let _id = queryString.parse(this.props.location.search).id;
    let action = "CADASTRAR";

    if (_id !== undefined) {
      action = "EDITAR";
    }

    this.setState(
      {
        _id,
        action,
      },
      () => {
        if (this.state.action === "CADASTRAR") {
          this.loadModulos();
        } else {
          this.loadPerfil(_id);
        }
      }
    );
  }

  async loadPerfil(_id) {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/perfis/${_id}`,
        this.props.parameters()
      )
      .then((response) => {
        let perfil = response.data.perfil;

        if(perfil === null){
          this.props.history.push('/perfis');
        }

        this.setState(
          {
            perfilEditar: perfil,
            desc: perfil.desc,
          },
          () => {
            this.loadModulos();
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  handleChangeInput(value, type) {
    this.setState({ [type]: value });
  }

  async cadastrar() {
    if (this.state.desc === "") {
      this.notificar("warning", "Favor informar a descrição!");
      return false;
    }

    let modulos = this.state.modulos;
    let modulosSelecionados = modulos.filter((it) => it.selecionado);

    if (modulosSelecionados.length === 0) {
      this.notificar("warning", "Favor selecionar pelo menos 1 módulo !");
      return false;
    }

    let perfil = {
      desc: this.state.desc,
      modulos: modulosSelecionados,
    };

    let url = `${this.props.getBaseUrlApi()}/perfis`;

    if (this.state.action === "EDITAR") {
      url = `${url}/${this.state._id}`;
    }

    await axios
      .post(url, { perfil }, this.props.parameters())
      .then((response) => {
        this.notificar(
          "success",
          `Perfil ${
            this.state.action === "CADASTRAR" ? "cadastrado" : "editado"
          } com sucesso!`
        );
        setTimeout(() => {
          this.props.history.push("/perfis");
        }, 1500);
      })
      .catch((error) => {
        console.log(error);
        this.notificar("warning", error.response.data.erro);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  async loadModulos() {
    await axios
      .get(`${this.props.getBaseUrlApi()}/modulos`, this.props.parameters())
      .then((response) => {
        let modulos = response.data.modulos;

        for (let modulo of modulos) {
          modulo.selecionado = false;
        }

        if (
          this.state.action === "EDITAR" &&
          this.state.perfilEditar !== null
        ) {
          let perfilEditar = this.state.perfilEditar;

          for (let moduloPerfil of perfilEditar.modulos) {
            for (let modulo of modulos) {
              if (modulo._id === moduloPerfil._id) {
                modulo.selecionado = true;
              }
            }
          }
        }

        this.setState({ modulos });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  onChangeModulo(isChecked, idModulo) {
    let modulos = this.state.modulos;
    for (let modulo of modulos) {
      if (modulo._id === idModulo) {
        modulo.selecionado = isChecked;
      }
    }
    this.setState({ modulos });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar
            title={`${
              this.state.action === "CADASTRAR" ? "Novo" : "Editar"
            } Perfil de Usuário`}
          />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"perfis"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  className=""
                                  style={{
                                    float: "left",
                                    width: "100%",
                                  }}
                                >
                                  <div className="d-flex flex-wrap w-100 float-left">
                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Descrição</label>
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            this.state.errors.desc
                                              ? "input-error"
                                              : ""
                                          }`}
                                          value={this.state.desc}
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e.target.value,
                                              "desc"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-flex flex-wrap w-100 float-left">
                                    <div className="table-responsive">
                                      <table className="table table-striped">
                                        <thead className="thead-dark">
                                          <th>Módulo</th>
                                          <th>Selecionado ?</th>
                                        </thead>
                                        <tbody>
                                          {this.state.modulos.map((modulo) => (
                                            <tr>
                                              <td>{modulo.desc}</td>
                                              <td>
                                                <div className="item-switch">
                                                  <Switch
                                                    checked={modulo.selecionado}
                                                    onChange={(chk) =>
                                                      this.onChangeModulo(
                                                        chk,
                                                        modulo._id
                                                      )
                                                    }
                                                    onColor="#f0e8fc"
                                                    onHandleColor="#7c3e7a"
                                                    handleDiameter={25}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                    height={16}
                                                    width={48}
                                                  />
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <button
                                      className="btn btn-success"
                                      onClick={this.cadastrar}
                                    >
                                      <i
                                        className="fa fa-plus"
                                        aria-hidden="true"
                                      ></i>
                                      &nbsp; Salvar
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
